'use strict';

var React = require('react'),
    _ = require('lodash');

var Title = React.createClass({
    displayName: 'Title',


    propTypes: {
        className: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array])
    },

    getDefaultProps: function getDefaultProps() {
        return {
            title: ''
        };
    },

    render: function render() {

        var props = _.assign({}, this.props);
        props.className = _.concat(['title'], this.props.className);

        if (_.has(this.props, 'onClick')) props.className = _.concat(['clickable'], props.className);

        props.className = props.className.join(' ');

        var title = props.title;
        delete props.title;

        return React.createElement(
            'span',
            props,
            title
        );
    }

});

module.exports = Title;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fdna-common-components/dist/components/Title/Title.js
// module id = 87
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 28 29 30